import { render } from "./adminbreadcrumb1.vue?vue&type=template&id=665c587b"
import script from "./adminbreadcrumb1.vue?vue&type=script&lang=js"
export * from "./adminbreadcrumb1.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__